const active = window.location.hash === "#debug";
let GUI = null;

// lil-gui is only needed with #debug, so it's loaded on demand to keep it out
// of the main bundle. Call this before creating the Experience.
export async function loadDebugUI() {
  if (active) {
    GUI = (await import("lil-gui")).default;
  }
}

export default class Debug {
  constructor() {
    this.active = active && GUI !== null;

    if (this.active) {
      this.ui = new GUI();
      this.ui.close();
      this.ui._closeFolders = true;
    }
  }
}
